import { MarkdownViewer } from "@expert/solve-tools";
import type { ExpertAssistMessage } from "../../shared-types";
import { generateSessionSummaryItem } from "../message-bubble/custom-messages/SessionSummary";
import { MessageTag } from "../timeline-item/elements";
import { Separator } from "../timeline-item/Separator";

export function generateTimelineItemFromType(message: ExpertAssistMessage) {
    switch (message.type) {
        case "Connection":
        case "Error":
        case "Expert":
        case "Default":
        case "QuickAction":
        case "Proactive":
        case "GuideRecommendation":
        case "Generic":
        case "Search":
        case "SmartOfferGeneric":
        case "SmartOfferResponse":
            return <MarkdownViewer content={message.text} />;
        case "SmartOffer":
            return (
                <>
                    {message.tag && <MessageTag tagName={message.tag} type="SmartOffer" />}
                    <MarkdownViewer content={message.text} />
                </>
            );
        case "SessionSummary": {
            const sessionSummary = message.metadata?.sessionSummary;
            return sessionSummary && generateSessionSummaryItem(sessionSummary);
        }
        case "Separator": {
            return <Separator label={message.text} />;
        }
    }
}
